import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import { MessageCircle, X } from "lucide-react";

export default function FloatingWhatsApp() {
  const { t } = useI18n();
  const [accounts, setAccounts] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/whatsapp").then((r) => setAccounts(r.data || [])).catch(() => setAccounts([]));
  }, []);

  if (!accounts.length) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40" data-testid="whatsapp-floating">
      {open && (
        <div className="mb-3 w-80 card-imperial p-5 shadow-2xl border-[#e6192b]/40" data-testid="whatsapp-panel">
          <div className="flex items-center justify-between mb-4">
            <div>
              <div className="overline">{t("whatsapp.title")}</div>
              <div className="font-serif text-xl mt-1">{t("whatsapp.subtitle")}</div>
            </div>
            <button onClick={() => setOpen(false)} className="text-neutral-500 hover:text-white" data-testid="whatsapp-close">
              <X size={18} />
            </button>
          </div>
          <div className="space-y-2">
            {accounts.map((a) => (
              <a
                key={a.id}
                href={`https://wa.me/${a.phone}?text=${encodeURIComponent(t("whatsapp.prefill"))}`}
                target="_blank"
                rel="noreferrer"
                className="block border border-[#222] hover:border-[#e6192b] p-3 transition-colors group"
                data-testid={`whatsapp-account-${a.id}`}
              >
                <div className="flex items-center gap-3">
                  <div className="h-9 w-9 rounded-full bg-[#e6192b]/10 flex items-center justify-center group-hover:bg-[#e6192b]/20 transition-colors">
                    <MessageCircle size={16} className="text-[#e6192b]" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-condensed text-sm tracking-wide text-white">{a.label}</div>
                    <div className="text-xs text-neutral-500 truncate">+{a.phone}{a.region ? ` · ${a.region}` : ""}</div>
                    {a.note && <div className="text-[10px] text-neutral-600 truncate">{a.note}</div>}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="whatsapp-toggle"
        className="h-14 w-14 rounded-full bg-black border-2 border-[#e6192b] hover:bg-[#e6192b] text-[#d4af37] hover:text-white shadow-xl flex items-center justify-center transition-all hover:scale-105"
        aria-label="WhatsApp support"
      >
        <MessageCircle size={24} />
      </button>
    </div>
  );
}
